/* The Vapetrix | r2: homepage-only GA4 tracking (uses the existing gtag / dataLayer; silent if neither exists).
   Events:
   - vtx_home_scroll          {percent: 25|50|75|90, locale, page_type:'home'}   once per percent per page view
   - vtx_home_section_click   {section_name, link_text, link_url, locale, page_type:'home'}
   Loaded only by the homepage template (templates/index*.json). */
(function () {
  'use strict';
  if (window.__vtxHomeTrack) return;
  window.__vtxHomeTrack = true;

  function loc() {
    try { return (window.Shopify && Shopify.locale) || document.documentElement.lang || ''; } catch (e) { return ''; }
  }
  function send(name, params) {
    try {
      params = params || {};
      params.locale = loc();
      params.page_type = 'home';
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
      else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var o = { event: name }; for (var k in params) { if (Object.prototype.hasOwnProperty.call(params, k)) o[k] = params[k]; }
        window.dataLayer.push(o);
      }
    } catch (e) { /* never break the page */ }
  }

  /* ---- scroll depth ---- */
  var marks = [25, 50, 75, 90], fired = {}, ticking = false;
  function check() {
    ticking = false;
    try {
      var doc = document.documentElement;
      var total = Math.max(doc.scrollHeight, document.body ? document.body.scrollHeight : 0);
      if (!total) return;
      var pct = ((window.pageYOffset || doc.scrollTop || 0) + (window.innerHeight || doc.clientHeight || 0)) / total * 100;
      for (var i = 0; i < marks.length; i++) {
        if (!fired[marks[i]] && pct >= marks[i]) { fired[marks[i]] = true; send('vtx_home_scroll', { percent: marks[i] }); }
      }
    } catch (e) {}
  }
  function onScroll() { if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(check, 16); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('load', function () { setTimeout(check, 1500); });

  /* ---- section clicks ---- */
  var NAMES = {
    vtx_hero: 'hero_slider', custom_liquid_RBmKJL: 'usp_marquee', custom_liquid_EfYcAw: 'device_row', seo_h1_custom_liquid: 'seo_intro',
    featured_collection_dHC7HA: 'best_sellers', featured_collection_taGXGM: 'just_landed', '178827214590edb2c5': 'reviews_carousel',
    image_with_text_jXUYFk: 'arizer_intro', featured_collection: 'arizer_row', '17882721891df2c4ad': 'reviews_snippet',
    image_with_text_bAXbcJ: 'potv_intro', featured_collection_potv: 'potv_row', featured_collection_NGizCj: 'venty_row',
    vtx_more_devices: 'more_for_your_device', rich_text_M3fCVA: 'about_vapetrix', featured_blog_htTrg6: 'blog_strip',
    multicolumn_QiVyj6: 'brand_cards', multicolumn_zHWfn6: 'brand_cards_2', image_with_text_cmjcKw: 'jonnys_blog', multicolumn_HDWPXk: 'info_reviews_cards'
  };
  function sectionName(el) {
    var sec = el.closest('.shopify-section');
    if (!sec) { return el.closest('footer') ? 'footer' : (el.closest('header') ? 'header' : ''); }
    if (/header|announcement/.test(sec.id) || sec.classList.contains('shopify-section-group-header-group')) return 'header';
    if (/footer/.test(sec.id) || sec.classList.contains('shopify-section-group-footer-group') || sec.querySelector('footer')) return 'footer';
    var m = sec.id.match(/__(.+)$/);
    var key = m ? m[1] : sec.id.replace(/^shopify-section-/, '');
    if (NAMES[key]) return NAMES[key];
    if (key.indexOf('featured_collection') === 0) return 'product_row_' + key.slice(-6);
    return key.replace(/[^a-z0-9_]/gi, '_').slice(0, 40);
  }
  function text(a) {
    var t = (a.getAttribute('aria-label') || a.getAttribute('title') || a.innerText || a.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t) { var img = a.querySelector('img[alt]'); if (img) t = img.getAttribute('alt') || ''; }
    return t.slice(0, 100);
  }
  document.addEventListener('click', function (e) {
    try {
      var t = e.target; if (!t || !t.closest) return;
      var a = t.closest('a[href], button, [role="button"]'); if (!a) return;
      var name = sectionName(a); if (!name || name === 'header') return;
      var href = a.getAttribute('href') || '';
      if (href && href.charAt(0) === '#') return;
      var url = '';
      try { url = href ? new URL(href, location.href).href : ''; } catch (er) { url = href; }
      send('vtx_home_section_click', { section_name: name, link_text: text(a), link_url: url.slice(0, 200) });
    } catch (er) {}
  }, true);
})();
